export default [
  {
    path: "/platformConfigurations/cashInMethods",
    component: () => import(/* webpackChunkName: "cashInMethods.layout" */ "../layout"),

    children: [
      {
        path: ":id",
        props: true,
        name: "platform.cashInMethods.show",
        component: () => import(/* webpackChunkName: "platform.cashInMethods" */ "./show.vue"),
      },
    ],
  },
];
